module.exports = __webpack_public_path__ + "img/image-7.d7dfb6ff.jpeg";